import slider from './slider';
import du from '../utils/dom-utilities';
import sliderTpl from '../templates/sliderTpl.js';

/**
 * Get data from DOM and return array of object
 *
 * @param {HTMLElement} sliderLightbox - A sliderLightbox node
 * @return {Object[]} data to insert
 */
function _getDataFromListImage(sliderLightbox) {
    const sliders = du.queryAll('.js-slider-lightbox-item', sliderLightbox);

    return sliders.map((elem, index) => {
        return {
            src: elem.querySelector('img').src,
            srcset: elem.querySelector('img').getAttribute('data-slider-srcset'),
            sizes: elem.querySelector('img').getAttribute('data-slider-sizes'),
            alt: elem.querySelector('img').alt,
            description: elem.querySelector('.js-slider-text-description').innerHTML,
            copyright: elem.querySelector('.js-slider-text-copyright').innerHTML,
            signature: elem.querySelector('.js-slider-text-signature').innerHTML,
            totalSlides: sliders.length,
            currentSlide: index + 1
        };
    });
}

/**
 * Init a slider-lightbox
 * @param {Lightbox} lightbox - The lightbox instance of the site
 */
export default function sliderLightbox(lightbox) {
    var options = {
        moduleSelector: '.slider-lightbox',
        itemSelector: '.js-load-lightbox'
    };

    du.queryAll(options.moduleSelector).forEach( sliderLightboxModule => {
        du.queryAll(options.itemSelector, sliderLightboxModule).forEach((sliderLightboxItem, index)=> {
            du.onEvent(sliderLightboxItem, 'click', () => {
                const listData = _getDataFromListImage(sliderLightboxModule);
                const content = lightbox.insertData(sliderTpl(listData));
                const sliderModule = content.querySelector('[data-slider-module]');

                const sliderObject = slider(sliderModule, index);
                lightbox.open(['lightbox--dark']);
                // Hack to fix slider init position when % width is used
                sliderObject.slider.slider.reset();
                sliderObject.slider.slider.slideTo(index);
            });

            du.onEvent(sliderLightboxItem, 'touchstart', () => {
                sliderLightboxItem.classList.add('is--touched');
            });

            du.onEvent(sliderLightboxItem, 'touchend', () => {
                sliderLightboxItem.classList.remove('is--touched');
            });
        });
    });
}



// WEBPACK FOOTER //
// ./src/main/js/components/slider-lightbox.js